/* eslint-disable ember/no-computed-properties-in-native-classes */
import Model, {
  attr,
  hasMany,
  type AsyncHasMany,
} from '@warp-drive/legacy/model';
import { computed } from '@ember/object';
import type { Type } from '@warp-drive/core/types/symbols';
import { fragment } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type GroupType from '@linc-technologies/linced-common/enums/group-type';
import type AutogroupParams from '@linc-technologies/linced-common/models/autogroup-params';
import { resolved } from '@linc-technologies/linced-common/utils/arrays';
import type UsageSet from 'linced-admin/models/schools/usage-set';

// Proto: groups.GroupTemplate.
export default class Group extends Model {
  declare [Type]: 'group';

  @attr('number')
  declare createTime: number | undefined;

  @attr('number')
  declare updateTime: number | undefined;

  @attr('string', { defaultValue: '' })
  declare profileMediaId: string;

  @attr('number', { defaultValue: 0 })
  declare type: EnumValue<typeof GroupType> | 0;

  @attr('number', { defaultValue: 0 })
  declare autoGroupType: number;

  @attr('string', { defaultValue: '' })
  declare name: string;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('number', { defaultValue: 0 })
  declare year: number;

  @attr('string', { defaultValue: '' })
  declare grouping: string;

  @attr('string', { defaultValue: '' })
  declare team: string;

  @fragment('autogroup-params')
  declare params: AutogroupParams | null;

  @attr('string', { defaultValue: '' })
  declare filter: string;

  // Usage sets membership
  @hasMany('schools/usage-set', { async: true, inverse: 'groupTemplateIds' })
  declare usageSetIds: AsyncHasMany<UsageSet>;

  @computed('usageSetIds.content.[]')
  get usageSetsArray() {
    return resolved(this.usageSetIds);
  }
}
